var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/customReduxHooks";
import { FlechasSliders } from "../../components/common/FlechasSlider/FlechasSlider";
import Loading from "../../components/Loading";
import TarjetaProducto from "../../components/tarjetas/Producto/TarjetaProducto";
import Coleccion from "../../components/tarjetas/Coleccion/Coleccion";
import Tienda from "../../components/tarjetas/Tienda/Tienda";
import Categoria from "../../components/tarjetas/Categoria/Categoria";
import { Top10Card } from "../../components/tarjetas/Top10Card/Top10Card";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { SlidersWrapper, ImagenDescriptiva, SliderInfoCategoria, ContainerSlider, } from "./SliderManagerStyled";
import BannerHero from "../../components/tarjetas/BannerHero/BannerHero";
import { MetodoDePago } from "../../components/tarjetas/MetodoDePago/MetodoDePago";
var defaultOptions = {
    type: "slide",
    autoplay: true,
    lazyLoad: "nearby",
    rewind: false,
    pagination: false,
    speed: 1000,
    interval: 10000,
    perMove: 1,
    padding: 0,
    arrows: true,
    componentStyle: {
        hasBorder: true,
        hasPadding: true,
        hasBackground: true,
        hasBorderRadius: true,
    },
};
var SliderManager = function (_a) {
    var empresa_id = _a.empresa_id, productos = _a.productos, settings = _a.settings, categorias = _a.categorias, className = _a.className, colecciones = _a.colecciones, tiendasOficiales = _a.tiendasOficiales, categoriasData = _a.categoriasData, _b = _a.type, type = _b === void 0 ? "default" : _b, estilosFlechas = _a.estilosFlechas, variant = _a.variant, diapositivas = _a.diapositivas, metodosDePago = _a.metodosDePago, eliminarTarjeta = _a.eliminarTarjeta;
    var _c = useState(defaultOptions), options = _c[0], setOptions = _c[1];
    useEffect(function () {
        setOptions(__assign(__assign({}, options), settings));
    }, [settings]);
    var componentes = useAppSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData) === null || _b === void 0 ? void 0 : _b.componentes; });
    var seleccionarColeccionCorrecta = function () {
        if (!productos &&
            !colecciones &&
            !tiendasOficiales &&
            !diapositivas &&
            !metodosDePago &&
            !categoriasData)
            return React.createElement(Loading, null);
        switch (type) {
            case "colecciones":
                return colecciones.map(function (coleccion) { return (React.createElement(SplideSlide, { key: coleccion.id, style: { display: "flex" } },
                    React.createElement(Coleccion, { coleccion: coleccion, url: coleccion.urlseo }))); });
            case "tiendasOficiales":
                return tiendasOficiales.map(function (tienda) { return (React.createElement(SplideSlide, { key: tienda.id, style: { display: "flex" } },
                    React.createElement(Tienda, { viewContext: "home", tienda: tienda }))); });
            case "diapositivas":
                return diapositivas.map(function (diapositiva, index) { return (React.createElement(SplideSlide, { key: "".concat(diapositiva.id, "-").concat(index) },
                    React.createElement(BannerHero, { diapositiva: diapositiva, empresa_id: empresa_id }))); });
            case "metodosDePago":
                return metodosDePago.map(function (metodoDePago) { return (React.createElement(SplideSlide, { key: metodoDePago.pmed_id, style: { display: "flex" } },
                    React.createElement(MetodoDePago, { metodoDePago: metodoDePago }))); });
            case "categoriasData":
                return categoriasData.map(function (categoria) { return (React.createElement(SplideSlide, { key: categoria.id },
                    React.createElement(Categoria, { categoria: categoria }))); });
            case "top10":
                return productos.map(function (producto, index) { return (React.createElement(SplideSlide, { key: producto.id },
                    React.createElement(Top10Card, { products: producto, number: index + 1 }))); });
            default:
                return productos.map(function (producto) { return (React.createElement(SplideSlide, { key: producto.id },
                    React.createElement(TarjetaProducto, { keyId: producto.id, producto: producto, contextoVisual: variant ? variant : "slide", eliminarTarjeta: eliminarTarjeta, hideTags: true, listsControlActive: variant !== "metodos-de-pago" }))); });
        }
    };
    return (React.createElement(SlidersWrapper, { className: className, style: options.componentStyle },
        categorias &&
            componentes &&
            !componentes.HOME_CATEGORIA_DESTACADA_IMAGEN_DESCRIPTIVA && (React.createElement(SliderInfoCategoria, null,
            "Nuevas Ofertas en",
            " ",
            React.createElement("a", { href: categorias.urlseo }, categorias.titulo))),
        categorias &&
            componentes &&
            componentes.HOME_CATEGORIA_DESTACADA_IMAGEN_DESCRIPTIVA && (React.createElement(ImagenDescriptiva, { background: categorias.imagen_descriptiva, featuredArticleImage: categorias.imagen_producto_destacado },
            React.createElement("h3", null, categorias.titulo),
            React.createElement("div", { className: "novedades-slider-titulo-underlay" }))),
        (!settings ||
            !settings.breakpoints ||
            (settings.breakpoints && options.breakpoints)) && (React.createElement(ContainerSlider, null,
            React.createElement(Splide, { options: options, hasTrack: false, style: { display: "flex" } },
                options.arrows && (React.createElement(FlechasSliders, { estilosFlechas: estilosFlechas })),
                React.createElement(SplideTrack, { style: { flex: 1 } }, seleccionarColeccionCorrecta()))))));
};
export default SliderManager;
